import { render, staticRenderFns } from "./LandingKnownFrom.vue?vue&type=template&id=48530676"
import script from "./LandingKnownFrom.vue?vue&type=script&lang=js"
export * from "./LandingKnownFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports